import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import { MemoryRouter, Route } from 'react-router-dom';
import Switch from "react-router-dom/es/Switch";
import jwt from 'jsonwebtoken';

import store from './store.js';
import Layout from "./components/Layout/Layout";
import setAuthorizationToken from "./utils/setAuthorizationToken";
import Login from "./components/Login/Login";
import Holiday from "./components/Holiday/Holiday";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import Scan from "./components/Nfc/Scan";
import requireAuth from "./requireAuth";

import { setAuthUser } from "./actions/AuthActions";
import { fetchMendixUser } from "./actions/UserActions";

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mendixUnavailable: false,
            appInitialized: false
        };

        this.initializeSession = this.initializeSession.bind(this);
    }

    componentDidMount() {
        this.initializeSession();
    }

    initializeSession() {
        const token = localStorage.getItem('jwtToken');

        if (!token) {
            this.setState({
                appInitialized: true
            });
            return;
        }

        setAuthorizationToken(token);

        const decodedUser = jwt.decode(token);

        if (!decodedUser) {
            localStorage.removeItem('jwtToken');
            setAuthorizationToken(false);

            this.setState({
                appInitialized: true
            });
            return;
        }

        store.dispatch(setAuthUser(decodedUser));

        store.dispatch(fetchMendixUser())
            .then(() => {
                this.setState({
                    appInitialized: true
                });
            })
            .catch(err => {
                if (err === "MENDIX_UNAVAILABLE" || (err && err.message === "MENDIX_UNAVAILABLE")) {
                    this.setState({
                        mendixUnavailable: true,
                        appInitialized: true
                    });
                    return;
                }

                this.setState({
                    appInitialized: true
                });
            });
    }

    render() {
        if (!this.state.appInitialized) {
            return null;
        }

        if (this.state.mendixUnavailable) {
            return (
                <div className="main-content">
                    <div className="container">
                        <div className="card small-padding m-t-42">
                            <h2 className="h1 m-b-sm">Urenboeken niet bereikbaar</h2>
                            <p>De mendix applicatie achter urenboeken is op dit moment niet bereikbaar, neem contact op met Maurice, Levi of Lieke.</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <MemoryRouter>
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/scan" component={Scan} />
                    <Route path="/holidays" component={requireAuth(Holiday)} />
                    <Route path="/change-password" component={requireAuth(ChangePassword)} />
                    <Route path="/holiday-overview" component={requireAuth(Layout)} />
                    <Route path="" component={requireAuth(Layout)} />
                </Switch>
            </MemoryRouter>
        );
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    };
}

const ConnectedApp = connect(mapStateToProps)(App);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedApp />
    </Provider>,
    document.getElementById('root')
);